/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { i18NAdminControllerBulkUpsertV1 } from '../fn/i-18-n-admin/i-18-n-admin-controller-bulk-upsert-v-1';
import { I18NAdminControllerBulkUpsertV1$Params } from '../fn/i-18-n-admin/i-18-n-admin-controller-bulk-upsert-v-1';
import { i18NAdminControllerCreateV1 } from '../fn/i-18-n-admin/i-18-n-admin-controller-create-v-1';
import { I18NAdminControllerCreateV1$Params } from '../fn/i-18-n-admin/i-18-n-admin-controller-create-v-1';
import { i18NAdminControllerDeleteV1 } from '../fn/i-18-n-admin/i-18-n-admin-controller-delete-v-1';
import { I18NAdminControllerDeleteV1$Params } from '../fn/i-18-n-admin/i-18-n-admin-controller-delete-v-1';
import { i18NAdminControllerExcelUploadV1 } from '../fn/i-18-n-admin/i-18-n-admin-controller-excel-upload-v-1';
import { I18NAdminControllerExcelUploadV1$Params } from '../fn/i-18-n-admin/i-18-n-admin-controller-excel-upload-v-1';
import { i18NAdminControllerFindByIdV1 } from '../fn/i-18-n-admin/i-18-n-admin-controller-find-by-id-v-1';
import { I18NAdminControllerFindByIdV1$Params } from '../fn/i-18-n-admin/i-18-n-admin-controller-find-by-id-v-1';
import { i18NAdminControllerSearchV1 } from '../fn/i-18-n-admin/i-18-n-admin-controller-search-v-1';
import { I18NAdminControllerSearchV1$Params } from '../fn/i-18-n-admin/i-18-n-admin-controller-search-v-1';
import { i18NAdminControllerUpdateV1 } from '../fn/i-18-n-admin/i-18-n-admin-controller-update-v-1';
import { I18NAdminControllerUpdateV1$Params } from '../fn/i-18-n-admin/i-18-n-admin-controller-update-v-1';
import { I18NDto } from '../models/i-18-n-dto';
import { I18NExcelResultDto } from '../models/i-18-n-excel-result-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class I18NAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `i18NAdminControllerSearchV1()` */
  static readonly I18NAdminControllerSearchV1Path = '/api/v1/i18n/admin/search';

  /**
   * 다국어 번역 검색 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NAdminControllerSearchV1$Response(params: I18NAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<I18NDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = i18NAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 다국어 번역 검색 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NAdminControllerSearchV1(params: I18NAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<I18NDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.i18NAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<I18NDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<I18NDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `i18NAdminControllerFindByIdV1()` */
  static readonly I18NAdminControllerFindByIdV1Path = '/api/v1/i18n/admin/{id}';

  /**
   * 다국어 번역 단일 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NAdminControllerFindByIdV1$Response(params: I18NAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NDto>> {
    const obs = i18NAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 다국어 번역 단일 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NAdminControllerFindByIdV1(params: I18NAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<I18NDto> {
    const resp = this.i18NAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<I18NDto>): I18NDto => r.body)
    );
  }

  /** Path part for operation `i18NAdminControllerDeleteV1()` */
  static readonly I18NAdminControllerDeleteV1Path = '/api/v1/i18n/admin/{id}';

  /**
   * 다국어 번역 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NAdminControllerDeleteV1$Response(params: I18NAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = i18NAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 다국어 번역 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NAdminControllerDeleteV1(params: I18NAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.i18NAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `i18NAdminControllerUpdateV1()` */
  static readonly I18NAdminControllerUpdateV1Path = '/api/v1/i18n/admin/{id}';

  /**
   * 다국어 번역 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  i18NAdminControllerUpdateV1$Response(params: I18NAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NDto>> {
    const obs = i18NAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 다국어 번역 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  i18NAdminControllerUpdateV1(params: I18NAdminControllerUpdateV1$Params, context?: HttpContext): Observable<I18NDto> {
    const resp = this.i18NAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<I18NDto>): I18NDto => r.body)
    );
  }

  /** Path part for operation `i18NAdminControllerCreateV1()` */
  static readonly I18NAdminControllerCreateV1Path = '/api/v1/i18n/admin';

  /**
   * 다국어 번역 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  i18NAdminControllerCreateV1$Response(params: I18NAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NDto>> {
    const obs = i18NAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 다국어 번역 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  i18NAdminControllerCreateV1(params: I18NAdminControllerCreateV1$Params, context?: HttpContext): Observable<I18NDto> {
    const resp = this.i18NAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<I18NDto>): I18NDto => r.body)
    );
  }

  /** Path part for operation `i18NAdminControllerBulkUpsertV1()` */
  static readonly I18NAdminControllerBulkUpsertV1Path = '/api/v1/i18n/admin/bulk';

  /**
   * 다국어 번역 일괄 등록/수정 (JSON).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NAdminControllerBulkUpsertV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  i18NAdminControllerBulkUpsertV1$Response(params: I18NAdminControllerBulkUpsertV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 생성된 항목 수
 */
'created'?: number;

/**
 * 수정된 항목 수
 */
'updated'?: number;
}>> {
    const obs = i18NAdminControllerBulkUpsertV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 다국어 번역 일괄 등록/수정 (JSON).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NAdminControllerBulkUpsertV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  i18NAdminControllerBulkUpsertV1(params: I18NAdminControllerBulkUpsertV1$Params, context?: HttpContext): Observable<{

/**
 * 생성된 항목 수
 */
'created'?: number;

/**
 * 수정된 항목 수
 */
'updated'?: number;
}> {
    const resp = this.i18NAdminControllerBulkUpsertV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{

/**
 * 생성된 항목 수
 */
'created'?: number;

/**
 * 수정된 항목 수
 */
'updated'?: number;
}>): {

/**
 * 생성된 항목 수
 */
'created'?: number;

/**
 * 수정된 항목 수
 */
'updated'?: number;
} => r.body)
    );
  }

  /** Path part for operation `i18NAdminControllerExcelUploadV1()` */
  static readonly I18NAdminControllerExcelUploadV1Path = '/api/v1/i18n/admin/excel';

  /**
   * 다국어 번역 엑셀 업로드.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NAdminControllerExcelUploadV1()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  i18NAdminControllerExcelUploadV1$Response(params: I18NAdminControllerExcelUploadV1$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NExcelResultDto>> {
    const obs = i18NAdminControllerExcelUploadV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 다국어 번역 엑셀 업로드.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NAdminControllerExcelUploadV1$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  i18NAdminControllerExcelUploadV1(params: I18NAdminControllerExcelUploadV1$Params, context?: HttpContext): Observable<I18NExcelResultDto> {
    const resp = this.i18NAdminControllerExcelUploadV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<I18NExcelResultDto>): I18NExcelResultDto => r.body)
    );
  }

}
